import { render, staticRenderFns } from "./RegularOrderScreen.vue?vue&type=template&id=22a216be&scoped=true&"
import script from "./RegularOrderScreen.vue?vue&type=script&lang=js&"
export * from "./RegularOrderScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a216be",
  null
  
)

export default component.exports